import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PackIllustration } from './PackIllustration';
import { images } from '../data/images';
import { offer } from '../data/offer';
const included = ['6 complete volumes, 300 pages', '77 ready-to-run sessions', '5 instant-use bonuses', 'A 3-Level Dial in every drill', '20 printable worksheets', 'Lifetime access to your files'];
export function Pricing() {
  const saving = offer.anchor - offer.price;
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-light text-ink" data-id="element-220" data-mp="1ru9hi3oa51ly">
      <div className="max-w-2xl mx-auto px-5 py-16 sm:py-20" data-id="element-221" data-mp="20t4ovj328hqu">
        <div className="text-center" data-id="element-222" data-mp="20rjvhwshf4uk">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-court" data-id="element-223" data-mp="3h7ec29vkg0g3">
            Complete pack
          </p>
          <h2 id="pricing-heading" className="mt-3 font-display font-bold text-ink text-[28px] leading-tight tracking-tight sm:text-5xl" data-id="element-224" data-mp="3c933e2h0bvzg">
            Everything you need for a full season of sessions
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-line bg-white shadow-card" data-id="element-225" data-mp="4uyvj1jo4aas">
          <div className="bg-court px-5 py-5 text-center" data-id="element-226" data-mp="9qe87q5xw05m">
            <h3 className="font-display text-xl font-bold tracking-tight text-white sm:text-2xl" data-id="element-227" data-mp="eq0gdl6wuq7k">
              Badminton Class Ready — Complete Pack
            </h3>
            <p className="mt-1 text-[13px] font-bold text-shuttle" data-id="element-228" data-mp="3i7irc1hzcdc7">
              6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-229" data-mp="3n5ka0lbhuan5">
            {images.pricing ? <img src={images.pricing} alt="Badminton Class Ready complete pack: six volumes and five bonuses" width={1200} height={886} loading="lazy" className="mx-auto w-full max-w-lg" data-id="element-230" data-mp="3ry3p5mptxdu2" /> : <PackIllustration className="mx-auto max-w-lg" data-id="element-231" data-mp="2rfjuj9slggki" />}

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-232" data-mp="2mijqf4fb1nw1">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm" data-id="element-233" data-mp="315mn58vszsib">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-green" data-id="element-234" data-mp="2w7utoafifyc0">
                    <CheckIcon className="h-3 w-3 text-white" aria-hidden="true" data-id="element-235" data-mp="28j20glq9w4l3" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-line pt-6 text-center" data-id="element-236" data-mp="2iggc88194572">
              <p className="text-[13px] text-ink-soft" data-id="element-237" data-mp="2dh3j55jse1w1">
                Total value{' '}
                <span className="text-ink-muted line-through" data-id="element-238" data-mp="3tvbqhsvzk4n3">${offer.anchor} USD</span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1" data-id="element-239" data-mp="3ow8vl19pzesu">
                <span className="mt-2.5 font-display text-3xl font-bold" data-id="element-240" data-mp="3oycz3i3pibsl">$</span>
                <span className="font-display text-6xl font-extrabold leading-[0.9] sm:text-7xl" data-id="element-241" data-mp="8sr730o6em7">
                  {offer.price}
                </span>
                <span className="mt-3 text-[13px] font-bold text-ink-muted" data-id="element-242" data-mp="3nfd0ot8bwv7y">USD</span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-243" data-mp="3rg58rj5gsu2n">
                <span className="rounded border border-shuttle bg-shuttle px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink" data-id="element-244" data-mp="j0vakm4p4905">
                  Save ${saving}
                </span>
                <span className="rounded border border-line px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink-soft" data-id="element-245" data-mp="a8jm35t56vmt">
                  One-time payment
                </span>
                <span className="rounded border border-line px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink-soft" data-id="element-246" data-mp="e7sh0dzx4zjy">
                  Lifetime access
                </span>
              </div>

              <CtaButton href={offer.checkoutUrl} className="mt-5" data-id="element-247" data-mp="3f78tsi0jrlha">
                Get Badminton Class Ready — only ${offer.price}
              </CtaButton>

              <p className="mt-3 text-xs text-ink-muted" data-id="element-248" data-mp="3a749si0fk8mb">
                Backed by the {offer.guaranteeDays}-day money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-ink-soft" data-id="element-249" data-mp="31892f2lngshf">
                <li className="flex items-center gap-1.5" data-id="element-250" data-mp="1rkmdzmfxkf6">
                  <LockIcon className="h-4 w-4 text-court" aria-hidden="true" data-id="element-251" data-mp="3syx1m93rjnsg" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-252" data-mp="3o75anxgp3g1s">
                  <ZapIcon className="h-4 w-4 text-court" aria-hidden="true" data-id="element-253" data-mp="3k6lfgzfommia" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-254" data-mp="kk5bd5z0r5dp">
                  <ShieldCheckIcon className="h-4 w-4 text-court" aria-hidden="true" data-id="element-255" data-mp="fsewqnt1tvgh" />
                  {offer.guaranteeDays}-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-ink-muted" data-id="element-256" data-mp="23dq0qauun1ng">
          Price in USD. You&apos;ll be charged the equivalent in your local
          currency.
        </p>
      </div>
    </section>;
}